(() => {
  const swatchSelector = '[data-card-product-swatch][data-card-swatch-preview-id]';
  const activeClass = 'is-active';
  const pendingClass = 'card-wrapper--swatch-pending';
  const previewClass = 'card-wrapper--swatch-preview';
  let previewId = 0;

  const getCardWrapper = (swatch) => swatch.closest('.card-wrapper');

  const getPreviewImage = (cardWrapper, previewImageId) =>
    Array.from(cardWrapper.querySelectorAll('[data-card-variant-preview-id]')).find(
      (image) => image.dataset.cardVariantPreviewId === previewImageId
    );

  const clearPreviewImages = (cardWrapper) => {
    cardWrapper
      .querySelectorAll('[data-card-variant-preview-id].is-active')
      .forEach((image) => image.classList.remove(activeClass));
  };

  const restoreCard = (cardWrapper) => {
    if (!cardWrapper) return;

    cardWrapper.dataset.cardSwatchPreviewId = '';
    cardWrapper.classList.remove(pendingClass, previewClass);
    clearPreviewImages(cardWrapper);
  };

  const showPreviewImage = (cardWrapper, previewImage, currentPreviewId) => {
    if (cardWrapper.dataset.cardSwatchPreviewId !== currentPreviewId) return;

    clearPreviewImages(cardWrapper);
    previewImage.classList.add(activeClass);
    cardWrapper.classList.remove(pendingClass);
    cardWrapper.classList.add(previewClass);
  };

  const previewImage = (swatch) => {
    const cardWrapper = getCardWrapper(swatch);
    const previewImageId = swatch.dataset.cardSwatchPreviewId;

    if (!cardWrapper || !previewImageId) return;

    const variantImage = getPreviewImage(cardWrapper, previewImageId);

    if (!variantImage) return;

    const currentPreviewId = `${Date.now()}-${++previewId}`;
    cardWrapper.dataset.cardSwatchPreviewId = currentPreviewId;
    cardWrapper.classList.add(pendingClass);
    cardWrapper.classList.remove(previewClass);
    clearPreviewImages(cardWrapper);

    if (variantImage.complete && variantImage.naturalWidth > 0) {
      showPreviewImage(cardWrapper, variantImage, currentPreviewId);
      return;
    }

    variantImage.addEventListener('load', () => showPreviewImage(cardWrapper, variantImage, currentPreviewId), {
      once: true,
    });
    variantImage.addEventListener('error', () => restoreCard(cardWrapper), { once: true });
  };

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest(swatchSelector);

    if (!swatch) return;

    previewImage(swatch);
  });

  document.addEventListener('pointerout', (event) => {
    const swatch = event.target.closest(swatchSelector);

    if (!swatch || swatch.contains(event.relatedTarget)) return;

    restoreCard(getCardWrapper(swatch));
  });

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest(swatchSelector);

    if (!swatch) return;

    previewImage(swatch);
  });

  document.addEventListener('focusout', (event) => {
    const swatch = event.target.closest(swatchSelector);

    if (!swatch) return;

    restoreCard(getCardWrapper(swatch));
  });
})();
